import $ from 'domtastic'
import Korg from 'reed-korg'
import BaseComponent from '@blocks/_BaseComponent'

import Results from '../../../templates/search-results.hbs'




/* GLOBAL SEARCH
----------------------------------------------------------------------------------------------------*/

export default class GlobalSearch extends BaseComponent {

    constructor($el) {
        super('GlobalSearch', $el, '.global')

        this.isOpen = false
        this.siteHandle = this.$el[0].dataset.site
        this.korg = new Korg(this.$refs.resultsCtn[0])

        this.keydownHandler  = (e) => { this.onKeydown(e) }

        this.events = [
            [document, 'layoutChange', () => { this.onResize() }],
            [document, 'pageWillChange', () => { this.onPageWillChange() }],
            [this.$refs.toggleBtn, 'click', (e) => { this.onButtonClick(e) }],
            [this.$refs.closeBtn, 'click', () => { this.toggle(false) }],
            [this.$refs.input, 'focus', () => { this.onInputFocus() }],
            [this.$refs.form, 'submit', (e) => { this.onFormSubmit(e) }],
            [this.$refs.input, 'input', (e) => { this.onInputChange(e) }],
        ]

        this.on()
    }




    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        if (!this.isOpen || APP.Layout.isDesktop) return

        this.toggle(false)
    }


    onPageWillChange() {
        this.toggle(false)
    }


    onButtonClick(e) {
        e.preventDefault()
        const { $input } = this.$refs

        $input[0].setSelectionRange(0, $input[0].value.length)

        this.toggle()
    }


    onKeydown(e) {
        // Escape
        if (e.keyCode === 27) {
            this.toggle(false)
        }
    }


    onInputFocus() {
        if (this.isOpen || !APP.Layout.isMobile) return

        this.toggle(true)
    }


    onFormSubmit(e) {
        e.preventDefault()
        this.fetchResults()
    }


    onInputChange({ target }) {
        clearTimeout(this.timer)

        if (target.value.length >= 3) {
            this.timer = setTimeout(() => {
                this.fetchResults()
            }, 200)
        } else {
            this.$refs.resultsCtn.empty()
            this.$el.removeClass('has-noResults')
        }
    }




    /* Actions
    --------------------------------------------------------- */

    toggle(shouldOpen = !this.isOpen) {
        if (shouldOpen === this.isOpen) return

        const { $doc, $body } = this.$utils
        const { $toggleBtn, $input } = this.$refs

        this.isOpen = shouldOpen
        clearTimeout(this.timer)

        this.$el.toggleClass('is-open', this.isOpen)
        $doc.trigger('overlayToggled', { isOpen : this.isOpen, trigger: 'globalSearch' })
        $toggleBtn.attr('aria-expanded', this.isOpen)

        this.korg.toggle(this.isOpen)

        if (this.isOpen) {
            $input[0].focus()

            this.timer = setTimeout(() => {
                $doc.on('keydown', this.keydownHandler)
            }, 200)
        } else {
            $doc.off('keydown', this.keydownHandler)
        }
    }


    fetchResults() {
        // Build GET url from form, seems a bit over-engineered
        const formData = new FormData(this.$refs.form.get(0))
        const searchParam = new URLSearchParams(formData)
        const urlObj = new URL(this.$refs.form.attr('action'))
        const newParams = new URLSearchParams({
            ...Object.fromEntries(urlObj.searchParams),
            ...Object.fromEntries(searchParam),
            site: this.siteHandle,
        })
        urlObj.search = newParams.toString()
        const url = urlObj.href


        fetch(url, fetchOptions)
            .then(response => (
                response.json()
            ))
            .then((r) => {
                this.handleResults(r.results)
                // send to datalayer
                const eventObj = {
                    event: 'search',
                    search_term: formData.get('t'),
                }
                // console.log(eventObj)
                if (typeof dataLayer !== 'undefined') { // eslint-disable-line no-undef
                    dataLayer.push(eventObj) // eslint-disable-line no-undef
                }
            })
    }


    handleResults(results) {
        this.$refs.resultsCtn.empty()

        this.$el.toggleClass('has-noResults', Boolean(results.length < 1))

        if (results.length) {
            this.$resultsEl = $(Results({ results }))
            this.$refs.resultsCtn.append(this.$resultsEl)
        } else {
            this.$resultsEl = null
        }
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const h = new Headers()
h.append('X-Requested-With', 'XMLHttpRequest')


const fetchOptions = {
    headers     : h,
    credentials : 'same-origin',
}



